/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify,
 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
import { NAMED_ENTITIES } from '@angular/compiler';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceHelperService {

  constructor(private http : HttpClient ) { }

  getUrl(entity: string) {
    // const apiGatewayUrl= "https://a239-196-179-229-156.eu.ngrok.io";

    const apiGatewayUrl= "https://03fe-196-179-229-156.ngrok-free.app";
    const url = `${apiGatewayUrl}/${entity}`;
    return url;
  }
  getUrlMDG(entity: string) {

   const apiGatewayMDGUrl= "https://etrade.menacp.net:10221/MDG";
    const url = `${apiGatewayMDGUrl}/${entity}`;
    return url;
  }


  getTenantName() {
    const hostname = window.location.hostname;  
    const parts = hostname.split('.');
    const tenantId = parts.length === 1 ? 'saascoffee' : parts[0];
    return tenantId;
  }


  VerifToken() {
      
    console.log ('ici nous verifions ')
    const headers = new HttpHeaders().set('x-access-token',localStorage.getItem("token"));
    const body = {email :localStorage.getItem("email")};
    const url = `${this.getUrl('User/Verify/')}`;
    console.log(url )
    return this.http.post(url,body,{ headers: headers });
    
  }



}

      